import { TitleCasePipe } from '@angular/common'
import { Component, inject, input, signal, OnInit } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { RouterLink } from '@angular/router'

import { AppConfigService } from 'app/app-config.service'

@Component({
  selector: 'app-terms-and-conditions',
  imports: [TitleCasePipe, RouterLink],
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.scss'
})
export class TermsAndConditionsComponent implements OnInit {
  private appConfig = inject(AppConfigService).getAppConfig
  sanitizer = inject(DomSanitizer)

  companyName = this.appConfig?.company_name ?? ''
  storefrontId = this.appConfig?.id ?? ''
  storeName = this.appConfig?.name ?? ''
  contactEmails: string[] = this.appConfig?.contact_emails ?? []
  privacyPolicyLink = input('/privacy-policy')

  trustedHtml = signal<SafeHtml | null>(null)
  ngOnInit() {
    const text = this.appConfig.data.settings?.termsAndConditionsText ?? ''
    // Check if empty. We need to strip tags because quill editor adds empty <p> tags
    const stripped = text.replace(/<[^>]+>/g, '').trim()
    if (stripped) {
      this.trustedHtml.set(this.sanitizer.bypassSecurityTrustHtml(text))
    }
  }
}
